import React, { Component, useState } from 'react';
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem 
} from 'reactstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useNavigate, matchPath, useParams, useLocation } from 'react-router-dom';

// import Lib from '../../../commons/lib';
import JegyeladasContent from './JegyeladasContent';
import Loader from '../../../commons/loader';
import Lib from "../../../commons/lib";

const JegyeladasBase = (props) => {
  // const [ activeTab, setActiveTab ] = useState(undefined);
  // const [ isHelyszinTabActive, setIsHelysinTabActive ] = useState(false);
  // const [ isTermekTabActive, setIsTermekTabActive ] = useState(false);
  // const [ isSzektorTabActive, setIsSzektorTabActive ] = useState(false);
  // const [ isJegyTabActive, setIsJegyTabActive ] = useState(false);
  // const [ isEmailTabActive, setIsEmailTabActive ] = useState(false);
  // const [ isRendelesekTabActive, setIsRendelesekTabActive ] = useState(false);
  // const [ isListakTabActive, setIsListakTabActive ] = useState(false);
  // const [ isMusorTabActive, setIsMusorTabActive ] = useState(false);


  // useEffect(() => {
  //   toggle('1');
  // }, [])

  // const toggle = (tab) => {
  //   setActiveTab(tab);
  // }

  // const onLogout = () => {
  //   props.globals.logout();
  // }

    console.log('f')
    const {
      params,
      id,
      globals,
      changePortalData,
      dismissPortal,
      history,
      match,
      rendeles
    } = props;

    const { eventId, rendelesId } = useParams();
    const { l } = useLocation();


    let cardStyle = {
      padding: 10
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="card">
            <div className="card-header">
              Helyszíni értékesítés
              {/* <YouTube data={videoData} /> */}
            </div>
            <div style={cardStyle}>
              <div className="col-md-12">
            {globals.keycloak.authenticated ?
              <JegyeladasContent
                {...props}
                l={l}
                globals={globals}
                changePortalData={changePortalData}
                dismissPortal={dismissPortal}
                eventId={eventId}
                rendelesId={rendelesId}
              />
            : <Loader />}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

JegyeladasBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default JegyeladasBase;
